import React from 'react';
import { X, Smartphone, Monitor, ArrowRight } from 'lucide-react';

interface MobileWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export default function MobileWarningModal({ isOpen, onClose, onProceed }: MobileWarningModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold flex items-center gap-2 text-gray-900">
            <Smartphone className="w-5 h-5" />
            Mobile Device Detected
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors group"
            aria-label="Close mobile warning modal"
          >
            <X className="w-5 h-5 text-gray-500 group-hover:text-gray-700" />
          </button>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-center gap-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <Smartphone className="w-6 h-6 text-yellow-600 flex-shrink-0" />
            <div>
              <p className="text-sm text-yellow-800 font-medium">
                You're using a mobile device
              </p>
              <p className="text-xs text-yellow-700">
                Limited screen space may affect the experience
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <Monitor className="w-6 h-6 text-green-600 flex-shrink-0" />
            <div>
              <p className="text-sm text-green-800 font-medium">
                Best experience on desktop
              </p>
              <p className="text-xs text-green-700">
                Code viewing, file navigation, and result analysis work better on larger screens
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={onProceed}
            className="w-full py-3 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
          >
            <ArrowRight className="w-4 h-4" />
            Proceed on Mobile
          </button>
          
          <button
            onClick={onClose}
            className="w-full py-2 px-4 bg-gray-100 text-gray-700 font-medium rounded-md hover:bg-gray-200 transition-colors"
          >
            I'll Switch to Desktop
          </button>
        </div>
        
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500">
            This warning won't appear again on this device
          </p>
        </div>
      </div>
    </div>
  );
}
